import { render } from "./DonantUpdate.html?vue&type=template&id=62e68ebe&external"
import script from "./DonantUpdate.vue?vue&type=script&lang=js"
export * from "./DonantUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__